/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Track_Labels_Main_Track_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Main Track" |
*
* @param {Track_Labels_Main_Track_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const track_labels_main_track_aria_label = /** @type {((inputs?: Track_Labels_Main_Track_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Track_Labels_Main_Track_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Piste principale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hauptgleis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pista principale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Главная трасса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pista principal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("主轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メイントラック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मुख्य ट्रैक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pista principal")
	return /** @type {LocalizedString} */ ("Main Track")
});